<template>
  <b-modal id="driving-license" ref="modal" size="lg" :title="title" @show="setModal" @hidden="resetModal" ok-title="Save"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Driving License Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.driving_license_type" :state="isEmpty(input_data.driving_license_type)" v-model="input_data.driving_license_type" :reduce="driving_license_type=>driving_license_type.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.registered_name)" v-model="input_data.registered_name" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.registered_number)" v-model="input_data.registered_number" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Height</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.height)" v-model="input_data.height" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Occupation</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.occupation)" v-model="input_data.occupation" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.expiration_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="description"
                      placeholder="Description"
                      rows="4"
                      v-model="input_data.description"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.status"
                      :options="options.status"
                      plain
                      name="plain-inline-status"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Default</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.default"
                      :options="options.default"
                      plain
                      name="plain-inline-default"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Is Locked</label>
                <div class="col-md-8 mb-3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="input_data.is_locked"
                      name="checkbox-1"
                      value="accepted"
                      unchecked-value="not_accepted"
                  >
                    Yes, Locked
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal, BFormTextarea, BFormRadioGroup, BFormCheckbox} from "bootstrap-vue"

import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "DrivingLicenseInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BButton,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      title:"Add",
      input_data:{
        driving_license_type:"",
        registered_name:"",
        registered_number:"",
        height:"",
        occupation:"",
        expiration_date:"",
        description:"",
        status:"active",
        default:false,
        is_locked:"accepted"
      },
      options:{
        driving_license_type:[],
        status:[{text:"Active", value:"active"}, { text:"Non Active", value:"non_active"}],
        default:[{text:"Yes", value:true}, { text:"No", value:"false"}],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    isEmpty(val){
      return val !== ""
    },
    onSubmit(){
      let payload = {
        emp_id: this.$store.getters.empId,
        drivlictype_id:this.input_data.driving_license_type,
        registered_number:this.input_data.registered_number,
        registered_name:this.input_data.registered_name,
        height:this.input_data.height,
        occupation:this.input_data.occupation,
        valid_date:this.input_data.expiration_date,
        status:(this.input_data.status === "active" ? 1:0),
        desc:this.input_data.description,
        user_id:this.$store.getters.userId
      }

      if (this.data !== null ){
        payload.id=this.data.id
        AxiosCall.Put(payload, urlApi.driving_license.update).then(res=>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errormessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.driving_license.add).then(res=>{
          if(res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }


    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.$parent.data = null
      this.title ="Add"
      this.input_data = {
        driving_license_type:"",
            registered_name:"",
            registered_number:"",
            height:"",
            occupation:"",
            expiration_date:"",
            description:"",
            status:"active",
            default:false,
            is_locked:"accepted"
      }
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    getLicensetype(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.driving_license.license_type).then(res=>{
        if(res.success){
          this.options.driving_license_type = res.atributes
        }else {
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    setModal(){
      setTimeout(()=>{
        if (this.data !== null){
          this.title = "Update"
          this.input_data.driving_license_type = this.data.type_id
          this.input_data.registered_name = this.data.registered_name
          this.input_data.registered_number = this.data.registered_number
          this.input_data.height = this.data.height
          this.input_data.occupation = this.data.occupation
          this.input_data.expiration_date = this.data.valid_until
          this.input_data.description = this.data.desc
          this.input_data.status = (this.data.status === 1?'active':'non_active')
          this.input_data.default = (this.data.is_default === "1" ? true:false)
          this.input_data.is_locked = (this.data.is_locked === 1 ? 'accepted':'')
        }
      }, 100)
    }
  },
  created() {
    this.getLicensetype()
  }
}
</script>